import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from '@services/baseQueryWithReAuth';

export const UTM_URL = import.meta.env.VITE_UTM_URL;

export const utmApi = createApi({
  reducerPath: 'utmApi',
  baseQuery: baseQueryWithReAuth,
  keepUnusedDataFor: 0,
  endpoints: () => ({}),
  tagTypes: ['Activation'],
});
